
      import AddToList from './add-to-list.vue'
      import type { App, Plugin } from 'vue'

      export const AddToListPlugin: Plugin = {
        install(app: App) {
          app.component('AddToList', AddToList)
        },
      }
      export { AddToList }
      